const config = {
  mineSites: {
    label: 'Mine Sites',
    source: '/assets/images/dashboard/select-icons/mine-sites.svg',
  },
  miningOperator: {
    label: 'Mine Operators',
    source: '/assets/images/dashboard/select-icons/operators.svg',
  },
  localTrader: {
    label: 'Local Trade Actors',
    source: '/assets/images/dashboard/select-icons/local-trade-actors.svg',
  },
  exporter: {
    label: 'Exporters',
    source: '/assets/images/dashboard/select-icons/exporters.svg',
  },
  globalTradeActors: {
    label: 'Global Trade Actors',
    source: '/assets/images/dashboard/select-icons/global-trade-actors.svg',
  },
  smelters: {
    label: 'Smelters / Refiners',
    source: '/assets/images/dashboard/select-icons/smelters.svg',
  },
  sources: {
    label: 'Information Sources',
    source: '/assets/images/dashboard/select-icons/sources.svg',
  },
  documents: {
    label: 'Documents',
    source: '/assets/images/dashboard/select-icons/documents.svg',
  },
};

export default config;
